import React from 'react'
import college from "../../../images/students/collegr.webp"
import chat from "../../../images/students/chat.webp"
import { LuCircleCheckBig, LuMessageCircle } from 'react-icons/lu'

export default function Gap() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center bg-[#F9FAFB]'>
            <h3 className='text-[#101828] text-[24px] md:text-[44px] font-semibold'>The Gap is not Academic. <br/> The Gap is Emotional, directional & behavioural.</h3>
            <div className='mt-[18px] md:mt-[32px] grid md:grid-cols-2 gap-[20px] md:gap-[50px] md:w-11/12 mx-auto text-start'>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={college} alt='college' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Colleges Said</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Our students hesitate during interviews.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>They lack clarity on career options.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Confidence is low.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Students need industry direction.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Mindset & behaviour need support.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={chat} alt='chat' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Students Said</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuMessageCircle className='text-[14px] md:text-[22px] text-[#007AFF] flex-shrink-0' />
                                <p>Anna… I’m confused.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuMessageCircle className='text-[14px] md:text-[22px] text-[#007AFF] flex-shrink-0' />
                                <p>I don’t know what suits me.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuMessageCircle className='text-[14px] md:text-[22px] text-[#007AFF] flex-shrink-0' />
                                <p>I’m scared of the future.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuMessageCircle className='text-[14px] md:text-[22px] text-[#007AFF] flex-shrink-0' />
                                <p>I don’t feel confident.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-[20px] md:mt-[32px] bg-[#007AFF1A] w-full md:w-9/12 mx-auto rounded-[12px] md:rounded-[20px] p-[15px] md:p-[24px] text-[#007AFF] text-center font-semibold text-[18px] md:text-[28px]'>
                <p>The gap is not academic. The gap is emotional, directional & behavioural.</p>
            </div>
        </div>
    )
}
